module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/marquee-3-46900800288eb3dff640c77176c66ac5.png";